import {
  Button,
  Card,
  Col,
  Divider,
  Pagination,
  Rate,
  Row,
  Space,
  Text,
  Typography,
} from "antd";
import Title from "antd/lib/typography/Title";
import React, { useState } from "react";
import getRelativeTime from "./getDateIntervals";
import ratingImage from "../../assets/images/ratingsIcon.svg";

const MyRatings = ({ ratingDetails }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(3);

  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const paginatedRatings = ratingDetails.slice(startIndex, endIndex);

  const totalRatings = ratingDetails.reduce(
    (sum, rating) => sum + rating.rating,
    0
  );
  const averageRating = totalRatings / ratingDetails.length;

  const formattedRating = (Math.round(averageRating * 10) / 10).toString();

  const handlePageChange = (page, newPageSize) => {
    setCurrentPage(page);
    if (newPageSize) {
      setPageSize(newPageSize);
    }
  };

  return (
    <div>
      <Card
        style={{
          borderRadius: "5px",
          padding: "1px",
        }}
      >
        <Row
          justify="space-between"
          align="middle"
          style={{
            borderRadius: "30px",
            padding: "16px",
          }}
        >
          <Col style={{ display: "flex", flexDirection: "column" }}>
            <Space>
              <Title level={4} className="myexim-table-title">
                Client Reviews & Ratings
              </Title>
            </Space>
            {ratingDetails.length > 0 ? (
              <Typography>from {ratingDetails.length} businesses</Typography>
            ) : (
              <Typography>Ratings will appear here once submitted</Typography>
            )}
          </Col>
          {ratingDetails.length > 0 ? (
            <Col style={{ display: "flex", gap: "20px" }}>
              <Space padding="10px">
                <img
                  src={ratingImage}
                  alt="rate-img"
                  style={{ height: "50px", width: "40px" }}
                />
              </Space>
              <Typography.Text strong style={{ fontSize: "30px" }}>
                {formattedRating}/5
              </Typography.Text>
            </Col>
          ) : (
            ""
          )}
        </Row>

        <Divider style={{ left: 0, top: "100px", position: "absolute" }} />

        <Row
          style={{
            marginTop: "16px",
          }}
        >
          <Col span={24}>
            {paginatedRatings.map((rating) => (
              <Card
                key={rating.id}
                style={{
                  marginBottom: "16px",
                  borderRadius: "0",
                  border: "none",
                  borderBottom: "1px solid #d9d9d9",
                }}
              >
                <Typography.Text
                  strong
                  style={{
                    fontSize: "16px",
                    display: "block",
                    marginBottom: "2px",
                  }}
                >
                  {rating.companyName}
                </Typography.Text>

                <Space align="center" style={{ marginBottom: "16px" }}>
                  <Rate
                    disabled
                    defaultValue={rating.rating}
                    style={{ color: "#faad14", fontSize: "16px" }}
                  />
                  <Typography.Text type="secondary" style={{ margin: "0 4px" }}>
                    •
                  </Typography.Text>

                  <Typography.Text
                    type="secondary"
                    style={{ color: "#727A84" }}
                  >
                    {getRelativeTime(rating.createdAt)}
                  </Typography.Text>
                </Space>

                <Typography.Paragraph>
                  {rating.ratingComments}
                </Typography.Paragraph>
              </Card>
            ))}
          </Col>
        </Row>
        <Row justify={"end"} style={{ marginTop: "16px" }}>
          <Col>
            <Pagination
              current={currentPage}
              pageSize={pageSize}
              total={ratingDetails.length}
              onChange={handlePageChange}
              onShowSizeChange={handlePageChange}
              showSizeChanger
              pageSizeOptions={[5]}
              showTotal={(total, range) =>
                `${range[0]}-${range[1]} of ${total} items`
              }
            />
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default MyRatings;
